import api from "../axios";

// cancel booking
export const cancelBookingApi = (data: any) => {
    return api.post("/booking/cancelbooking", {
        bookid: data.bookingid,
        reason: data.cancelreason,
        cancelledby: data.cancelledby,
        canceltype: data.canceltype ?? 2,
        cabid: data.cabid ?? undefined,
        remarks: data.remarks ?? "",
    });
};;

// assign trip
export const assignTripApi = (data: any) => {
    return api.post("/booking/assigntrip", data);
};

// get new booking
export const getNewBookingsApi = (branchid: any) => {
    return api.get(`/booking/getNewbooking?branchid=${branchid}&t=${Date.now()}`);
}

// Cancel reason
export const getCancelReasonApi = (canceltype: any) => {
    return api.get(`/booking/getcancelreason?canceltype=${canceltype}`);
};

// auto assign trip
export const autoAssignTripApi = (data: any) => {
    return api.post("/booking/autoassigntrip", {
        bookid: data.bookid,
        assignedby: data.assignedby,
        emptyKM: data.emptyKM ?? 0,
        cityid: data.cityid,
        vehicletype: data.vehicletype,
        fromlat: data.fromlat,
        fromlong: data.fromlong,
    });
};


export const getAvailableCabsRadiusApi = (
    branchid: string,
    vehicletype: number,
    fromlat: string,
    fromlong: string
) => {
    return api.get("/booking/getavailablecabsradius", {
        params: {
            branchid,
            vehicletype,
            fromlat,
            fromlong,
        },
    });
};

// get selected cab
export const getSelectedCabApi = (
    cabid: string,
    fromlat: string,
    fromlong: string
) => {
    return api.get("/booking/getselectedcab", {
        params: {
            cabid,
            fromlat,
            fromlong,
        },
    });
};